function convertToCSV(args) {  
  var result, ctr, keys, columnDelimiter, lineDelimiter, data;

  data = args.data || null;
  if (data == null || !data.length) {
      return null;
  }

  columnDelimiter = args.columnDelimiter || ',';
  lineDelimiter = args.lineDelimiter || '\n';

  keys = Object.keys(data[0]);

  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  data.forEach(function(item) {
      ctr = 0;
      keys.forEach(function(key) {
          if (ctr > 0) result += columnDelimiter;

          result += "\"" + item[key] + "\"";
          ctr++;
      });
      result += lineDelimiter;
  });

  return result;
}

export default function downloadCSV(args) {
  var data, filename, link;
  
  data = args.data || null;
  if (data == null || !data.length) {
      return null;
  }

  var csv = convertToCSV({
    data: args.data
  });

  if (csv == null) return;
  
  filename = `${args.filename ? args.filename : 'data'}.csv`;
  
  var blob = new Blob([csv], {type: "text/csv;charset=utf-8;"});
  
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, filename)
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style = "visibility:hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}


// WEBPACK FOOTER //
// ./downloadCSV.js